<div class="ctooltip"><slot name="title">hover</slot><div class="ctooltip-slot" :style="style"><slot name="content">tooltip</slot></div></div>